module.exports = __webpack_public_path__ + "static/media/isi_logo.8d7c3c06.png";